import { Database, HardDrive, type LucideIcon, Trash2 } from 'lucide-react';
import { msg } from '@/shared/i18n/msg';

type DataTab = {
  readonly value: 'sync' | 'storage' | 'trash';
  /** An English key, translated where it is rendered. */
  readonly label: string;
  readonly icon: LucideIcon;
};

/** The tabs of /data, one route each (`/data/sync`…), so the breadcrumb and back work. */
export const DATA_TABS: readonly DataTab[] = [
  { value: 'sync', label: msg('Sync'), icon: Database },
  { value: 'storage', label: msg('Storage'), icon: HardDrive },
  { value: 'trash', label: msg('Trash'), icon: Trash2 },
];
